import React from "react";
import ImageCarousel from "./ImageCarousel";
import { portfolio } from "../Constants/Constants";
import { motion } from "framer-motion";

export default function Portfolio() {
  return (
    <div>
      <motion.div
        className="portfolioTitleDiv text-center mb-5"
        initial={{ opacity: 0, y: 75 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <h5 className="portfolioTitle">portfolio</h5>
        <h2 className="portfolioTitle">Some of my works.</h2>
      </motion.div>

      <div className="portfolioProjects row justify-content-center gap-5">
        {portfolio.map((singleProject, index) => {
          return (
            <div className="col-lg-4 col-md-4 col-12" key={index}>
              <motion.div
                className="singlePortfolio"
                initial={{ opacity: 0, y: 75 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1 }}
              >
                <div className="portfolio-content">
                  <ImageCarousel images={singleProject.images} />
                  <h3 className="mt-2 pt-3">{singleProject.title}</h3>
                  <p>{singleProject.description}</p>
                </div>

                <div className="singleProjectBtnDiv d-flex justify-content-center">
                  {singleProject.link ? (
                    <button className="singleProjectBtn">
                      <a
                        href={singleProject.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Visit Website
                      </a>
                    </button>
                  ) : singleProject.github ? (
                    <button className="singleProjectBtn github-btn">
                      <a
                        href={singleProject.github}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View on GitHub
                      </a>
                    </button>
                  ) : (
                    <button className="singleProjectBtn disabled-btn" disabled>
                      Link not available
                    </button>
                  )}
                </div>
              </motion.div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
